export const userConstants = {
    LOADING_USERS: 'LOADING_USERS',
    LOADING_USERS_ERROR: 'LOADING_USERS_ERROR',
    USER_SET_IS_LOADING: 'USER_SET_IS_LOADING',
    DELETE_USER: 'DELETE_USER',
    DELETE_USER_ERROR: 'DELETE_USER_ERROR',
    INVITE_MEMBER_LOADING_SPINNER: 'INVITE_MEMBER_LOADING_SPINNER',
    INVITE_MEMBER: 'INVITE_MEMBER',
};
